import { Component, OnInit } from '@angular/core';
import { AccountService } from '../@tools/account';

@Component({
    selector: 'app-auth',
    templateUrl: './auth.component.html',
    styleUrls: [ './auth.component.scss' ]
})
export class AuthComponent implements OnInit {

    phone;
    code;
    stage = 0;


    constructor(private account: AccountService) {
    }

    ngOnInit() {
    }

    nextStage() {
        if (this.phone) {
            this.account.generateCode({ phone: this.phone }).then(res => {
                this.stage = 1;
            });
        }
    }

    auth() {
        if (this.code) {
            this.account.login({phone: this.phone, code: this.code}).then(res => {
                this.phone = '';
                this.code = '';
                this.stage = 0;
            });
        }
    }
}
